import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import MaterialInput from './MaterialInput'

import './index.scss'

import { omit } from 'lodash'

/**
 * @example
 * <Text
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Text" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   placeholder={<FormattedMessage id="SomePlaceholder" defaultMessage="Some Placeholder" />}
 *   required
 * />
 */
const Text = ({ className, onChange, variant, ...props }: any) => {
  const fieldProps = {
    ...props,
    className: cn(
      'form__text',
      {
        'material-text': variant === 'material',
        'material-outlined': variant === 'material-outlined',
        'form__field--icon': !!props.icon
      },
      className
    ),
    label: props.placeholderAsTitle ? undefined : props.label
  }

  return (
    <Field
      {...fieldProps}
      render={({ formik, icon, ...field }: any) => {
        const inputProps = {
          required: props.required,
          ...field,
          onBlur: handleBlur(formik, props.onBlur),
          ...(props.placeholderAsTitle && { placeholderAsTitle: props.placeholderAsTitle }),
          onKeyDown: props.onKeyDown,
          onChange: handleChange(formik, onChange),
          ref: props.inputref,
          subtitle: props.subtitle,
          min: props.min
        }

        if (variant === 'material' || variant === 'material-outlined') {
          return <MaterialInput {...inputProps} />
        } else {
          return props.subtitle ? (
            <div>
              <div className="pb-1 text-sm text-gray-600">{props.subtitle}</div>
              <input {...omit(inputProps, ['afterInput'])} />
              {!!icon && <span className="field__icon">{icon}</span>}
              {!!props.titlelabel && <span className="field__title__label">{props.titlelabel}</span>}
              {props.afterInput}
            </div>
          ) : (
            <>
              <input {...omit(inputProps, ['afterInput'])} />
              {!!icon && <span className="field__icon">{icon}</span>}
              {!!props.titlelabel && <span className="field__title__label">{props.titlelabel}</span>}
              {props.afterInput}
            </>
          )
        }
      }}
    />
  )
}
const handleBlur = (formik: any, onBlur: any) => {
  return (e: any) => {
    if (onBlur) {
      onBlur(e)
    }
    if (formik.handleBlur) formik.handleBlur(e)
  }
}
const handleChange = (formik: any, onChange: any) => {
  return (e: any) => {
    if (onChange) {
      onChange(e)
    }

    if (formik.handleChange) formik.handleChange(e)
  }
}

Text.displayName = 'Text'

Text.propTypes = {
  ...propTypes,
  icon: PropTypes.element,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  inputref: PropTypes.object,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  min: PropTypes.number,
  titlelabel: PropTypes.string,
  afterInput: PropTypes.element,
  maxLength: PropTypes.number,
  spellCheck: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.string
}

Text.defaultProps = {
  ...defaultProps,
  icon: null,
  autoFocus: false,
  onChange: null,
  placeholder: '',
  type: 'text',
  titlelabel: ''
}

export default Text
